import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Meta } from 'types/meta';
import { Location } from 'types/location';
import { getTranslation } from 'localization/helpers';
import { SelectArea } from 'styles/Form/SelectArea';
import { TextInputContainer } from 'styles/Form/TextInputContainer';

interface ShareBlockProps {
  meta: Meta;
  locations: Location[];
  changeLocation: (location: Location) => void;
}

export const LocationSelectionBlock: FC<ShareBlockProps> = ({
  meta,
  locations,
  changeLocation
}) => {
  const { i18n } = useTranslation();
  const [chosenLocation, setChosenLocation] = useState(locations[0]);
  return (
    <TextInputContainer>
      <SelectArea
        size={0}
        value={chosenLocation.hash}
        onChange={value => {
          const newLocation = locations.find(
            l => l.hash === value.target.value
          ) as Location;
          setChosenLocation(newLocation);
          changeLocation(newLocation);
        }}
      >
        {locations.map(l => (
          <option value={l.hash} key={l.hash}>
            {getTranslation(
              l.translations,
              'address',
              i18n.language,
              meta.default_locale
            )}
          </option>
        ))}
      </SelectArea>
    </TextInputContainer>
  );
};
